import {HelpTexts} from "i18n/containers/Help";
import {HelpTranslation} from "i18n/containers/Help/typing";
import * as React from "react";
import Header from "semantic-ui-react/dist/commonjs/elements/Header";
import Segment from "semantic-ui-react/dist/commonjs/elements/Segment";
import {useLocales} from "@libs";

const HELP_FORM_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLSf7EPqO_zhsUiwL4wB35imEicJKFFtbDDhMiB-mSakblK3S8Q/viewform";

const Help = () => {
    const {currentShortLocale} = useLocales();
    const helpTranslation: HelpTranslation = {
        ...HelpTexts[currentShortLocale],
    };

    return (
        <div className="Help padding-2-all">
            <Header
                className="margin-2-bottom"
                as="h2"
                dividing
                disabled
            >
                {helpTranslation.title}
            </Header>
            <Segment attached="bottom">
                <p>{helpTranslation.description}</p>
                <a
                    href={HELP_FORM_URL}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                >
                    {helpTranslation.goToTheForm}
                </a>
            </Segment>
        </div>
    );
};

export default React.memo(Help);
